/* eslint-disable no-dupe-keys */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";
import Content from "../../layout/content/Content";
import { Spinner } from "reactstrap";
import {
  Button,
  Block,
  BlockDes,
  Icon,
  Col,
  Row,
} from "../../components/Component";

import Head from "../../layout/head/Head";
import OptionM from "../components/DynmicOption/OptionM";
import OptionC from "../components/DynmicOption/OptionC";
import { DownloadTableExcel } from "react-export-table-to-excel";
import CenterOption from "../components/DynmicOption/CenterOption";

export const ReportJobsikers = () => {
  const [centergen, setCntergen] = useState(false);
  const [Statee, setStatee] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const month1 = [
    "Test",
    "JANUARY",
    "FEBRUARY",
    "MARCH",
    "APRIL",
    "MAY",
    "JUNE",
    "JULY",
    "AUGUST",
    "SEPTEMBER",
    "OCTOBER",
    "NOVEMBER",
    "DECEMBER",
  ];
  const today = new Date();
  const [formData, setFormData] = useState({
    month:
      sessionStorage.getItem("CurrentMonth") ||
      (today.getMonth() === 0 ? 12 : today.getMonth()),
    dummymonth:
      month1[sessionStorage.getItem("CurrentMonth") || today.getMonth()],
    year:
      sessionStorage.getItem("CurrentYear") ||
      (today.getMonth() === 0 ? today.getFullYear() - 1 : today.getFullYear()),
    tomonth:
      sessionStorage.getItem("CurrentMonth2") ||
      (today.getMonth() === 0 ? 12 : today.getMonth()),
    todummymonth:
      month1[sessionStorage.getItem("CurrentMonth2") || today.getMonth()],
    toyear:
      sessionStorage.getItem("CurrentYear2") ||
      (today.getMonth() === 0 ? today.getFullYear() - 1 : today.getFullYear()),
    EmploymentRefId: 10,
    state: 0,
    generate: 0,
    CenterId: 0,
  });
  const [generate1, setgenerate1] = useState(false);
  const [selectcenter, setselctcenter] = useState(false);
  const tableRef = useRef(null);

  const getData = async () => {
    setLoading(true);
    setError(null); // Clear previous errors
    const requestData = {
      YearId: Number(formData.year),
      MonthId: Number(formData.month),
      ToYearId: Number(formData.toyear),
      ToMonthId: Number(formData.tomonth),
      UserId: Number(formData.CenterId),
    };

    //console.log("Request Data: ", requestData);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_LINK}api/NCSCDA/JobFair`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        }
      );

      if (!response.ok) {
        // Handle HTTP errors
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      //console.log("Response Data: ", data);
      setStatee(data);
    } catch (error) {
      console.error("Error fetching data: ", error);
      setError("Error loading data. Please try again later.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (generate1) {
      getData();
    }
  }, [generate1, formData]);
  const onInputChange = (month, year) => {
    setCntergen(false);
    setFormData({ ...formData, month: month, year: year });
  };

  const onInputChange2 = (tomonth, toyear) => {
    setCntergen(false);
    setFormData({ ...formData, tomonth: tomonth, toyear: toyear });
  };
  const onInputChangeCenter = (e) => {
    setCntergen(false);
    setselctcenter(false);
    setFormData({ ...formData, CenterId: e.target.value });
  };
  useEffect(() => {
    setgenerate1(false);
  }, [window.location.search]);

  const generate = async () => {
    setCntergen(true);
    setgenerate1(true);
    if (formData.CenterId === 0) {
      setselctcenter(true);
    }
  };
  return (
    <React.Fragment>
      <Head title={"Jobfairs"} />

      <Content>
        <Block>
          <BlockDes className="text-soft">
            <Row>
              <Col xl="3" md="3">
                <h5 style={{ color: "#798bff" }}>DA Dashboard</h5>
              </Col>
              <Col xl="3" md="3">
                <label style={{ color: "black", fontSize: 14 }}>
                  {" "}
                  Center :{" "}
                  <label style={{ fontWeight: "bold" }}>
                    <CenterOption
                      defaultValuemain={formData.CenterId}
                      catid="42"
                      onInputChange={onInputChangeCenter}
                      namemain="year"
                      mainid="year"
                    />
                  </label>
                </label>
              </Col>

              <Col xl="3" md="3">
                <label
                  style={{ color: "black", fontSize: 12, fontWeight: "bold" }}
                >
                  {" "}
                  From:{" "}
                  <label style={{ fontWeight: "bold" }}>
                    <OptionC
                      defaultValuemain={formData.year}
                      catid="42"
                      onInputChange={onInputChange}
                      namemain="year"
                      mainid="year"
                    />
                  </label>
                </label>
              </Col>

              <Col xl="3" md="3">
                <label style={{ color: "black", fontSize: 15 }}>
                  {" "}
                  To:{" "}
                  <label style={{ fontWeight: "bold" }}>
                    <OptionM
                      onInputChange={onInputChange2}
                      year={formData.year}
                      month={formData.month}
                      tomonth={formData.tomonth}
                      toyear={formData.toyear}
                    />
                  </label>
                </label>
              </Col>
              {centergen === false && (
                <Col xl="3" md="3">
                  <Button
                    color="success"
                    style={{ marginTop: 10 }}
                    onClick={() => generate()}
                  >
                    Generate
                  </Button>
                </Col>
              )}
            </Row>
          </BlockDes>
          <hr />

          {/*hidden table*/}

          {Statee.length > 0 && (
            <table
              className="table table-orders"
              ref={tableRef}
              style={{
                borderCollapse: "separate",
                borderSpacing: 0,
                border: "1px solid black",
                display: "none",
              }}
            >
              <thead
                style={{
                  position: "sticky",
                  top: 0,
                  backgroundColor: "#edecec",
                }}
              >
                <tr className="export-only">
                  <th colSpan="2" style={tableHeaderStyle}>
                    Form: {"Jobfairs Report"}
                  </th>
                  <th colSpan="2" style={tableHeaderStyle}>
                    From Date: {month1[formData.month]} {formData.year}
                  </th>
                  <th colSpan="2" style={tableHeaderStyle}>
                    To Date: {month1[formData.tomonth]} {formData.toyear}
                  </th>
                </tr>
              </thead>
              <thead
                style={{
                  position: "sticky",
                  top: 0,
                }}
              >
                <tr>
                  <td
                    style={{
                      position: "sticky",
                      left: 0,
                      ...tableHeaderStyle,
                    }}
                  >
                    NCSC-DA
                  </td>
                  <td style={tableHeaderStyle}>No. of Job Fairs Organised</td>
                  <td style={tableHeaderStyle}>
                    No. of Job Seekers Participated
                  </td>
                  <td style={tableHeaderStyle}>
                    No. of Employers Participated
                  </td>
                  <td style={tableHeaderStyle}>
                    No. of Jobseekers placed/shortlisted
                  </td>
                  <td style={tableHeaderStyle}>
                    No. of Candidates registered under NCS Portal
                  </td>
                </tr>
              </thead>
              {Statee.length !== 0 &&
                Statee.filter(
                  (details) =>
                    formData.CenterId === 0 ||
                    details.stateName !== "Grand Total"
                ).map((details, index) => (
                  <tbody key={index}>
                    <tr
                      style={{
                        borderCollapse: "separate",
                        borderSpacing: 0,
                        verticalAlign: "inherit",
                        color: "black",
                        ...leftColumnCell,
                      }}
                    >
                      <th
                        style={{
                          position: "-webkit-sticky",
                          position: "sticky",
                          left: 0,
                          top: 65,
                          backgroundColor: "#eaf8dd",
                          fontWeight: "bold",
                          minWidth: 100,
                          ...leftColumnCell,
                        }}
                      >
                        {details.stateName}
                      </th>
                      <th style={leftColumnCell}>
                        {details.jobFairsOrganised}
                      </th>
                      <th style={leftColumnCell}>
                        {details.jobSeekersParticipated}
                      </th>
                      <th style={leftColumnCell}>
                        {details.employersParticipated}
                      </th>
                      <th style={leftColumnCell}>
                        {details.jobseekersplacedshortlisted}
                      </th>
                      <th style={leftColumnCell}>
                        {details.candidatesregisteredunderNCSPortal}
                      </th>
                    </tr>
                  </tbody>
                ))}
            </table>
          )}

          {generate1 ? (
            centergen === true ? (
              <>
                <Row>
                  <Col md="2" lg="3"></Col>
                  <Col md="2" lg="3"></Col>
                  <Col md="2" lg="3"></Col>
                  {!loading && (
                    <Col md="2" lg="3">
                      {!loading && Statee.length > 0 && (
                        <DownloadTableExcel
                          filename={`Jobfairs (${month1[formData.month]}-${
                            formData.year
                          } to ${month1[formData.tomonth]}-${formData.toyear})`}
                          sheet="Report Data"
                          currentTableRef={tableRef.current}
                        >
                          <Button
                            style={{ float: "right", marginBottom: 10 }}
                            color="info"
                          >
                            <Icon className="icon ni ni-download"></Icon>Export
                            Excel
                          </Button>
                        </DownloadTableExcel>
                      )}
                    </Col>
                  )}
                </Row>
                {loading ? (
                  <div>
                    <h3
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      Please wait while the report is loading......
                    </h3>
                    <br />
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Spinner size="xl" />
                    </div>
                  </div>
                ) : error ? (
                  <h3>{error}</h3>
                ) : Statee.length === 0 ? (
                  <h3>No Data Available for Selected Months</h3>
                ) : (
                  <div
                    style={
                      selectcenter === true
                        ? {
                            height: window.innerHeight - 100,
                            width: "auto",
                            overflow: "scroll",
                          }
                        : {
                            height: window.innerHeight - 300,
                            width: "auto",
                            overflow: "scroll",
                          }
                    }
                    className="table-responsive"
                  >
                    <table
                      className="table table-orders"
                      style={{
                        borderCollapse: "separate",
                        borderSpacing: 0,
                        border: "1px solid black",
                      }}
                    >
                      <thead
                        style={{
                          position: "sticky",
                          top: 0,
                          backgroundColor: "#edecec",
                        }}
                      >
                        <tr className="export-only">
                          <th colSpan="3" style={tableHeaderStyle}>
                            Form: {"Jobfairs Report"}
                          </th>
                          <th colSpan="3" style={tableHeaderStyle}>
                            From Date: {month1[formData.month]} {formData.year}
                          </th>
                          <th colSpan="3" style={tableHeaderStyle}>
                            To Date: {month1[formData.tomonth]}{" "}
                            {formData.toyear}
                          </th>
                        </tr>
                      </thead>
                      <thead
                        style={{
                          position: "sticky",
                          top: 0,
                        }}
                      >
                        <tr>
                          <td
                            style={{
                              position: "sticky",
                              left: 0,
                              ...tableHeaderStyle,
                            }}
                          >
                            NCSC-DA
                          </td>
                          <td style={tableHeaderStyle}>
                            No. of Job Fairs Organised
                          </td>
                          <td style={tableHeaderStyle}>
                            No. of Job Seekers Participated
                          </td>
                          <td style={tableHeaderStyle}>
                            No. of Employers Participated
                          </td>
                          <td style={tableHeaderStyle}>
                            No. of Jobseekers placed/shortlisted
                          </td>
                          <td style={tableHeaderStyle}>
                            No. of Candidates registered under NCS Portal
                          </td>
                        </tr>
                      </thead>
                      {Statee.length !== 0 &&
                        Statee.filter(
                          (details) =>
                            formData.CenterId === 0 ||
                            details.stateName !== "Grand Total"
                        ).map((details, index) => (
                          <tbody key={index}>
                            <tr
                              style={{
                                borderCollapse: "separate",
                                borderSpacing: 0,
                                verticalAlign: "inherit",
                                color: "black",
                                ...leftColumnCell,
                              }}
                            >
                              <th
                                style={{
                                  position: "-webkit-sticky",
                                  position: "sticky",
                                  left: 0,
                                  top: 65,
                                  backgroundColor: "#eaf8dd",
                                  fontWeight: "bold",
                                  minWidth: 100,
                                  ...leftColumnCell,
                                }}
                              >
                                {details.stateName}
                              </th>
                              <th style={leftColumnCell}>
                                {details.jobFairsOrganised}
                              </th>
                              <th style={leftColumnCell}>
                                {details.jobSeekersParticipated}
                              </th>
                              <th style={leftColumnCell}>
                                {details.employersParticipated}
                              </th>
                              <th style={leftColumnCell}>
                                {details.jobseekersplacedshortlisted}
                              </th>
                              <th style={leftColumnCell}>
                                {details.candidatesregisteredunderNCSPortal}
                              </th>
                            </tr>
                          </tbody>
                        ))}
                    </table>
                  </div>
                )}
              </>
            ) : (
              <h3>Please Click On Generate Button for Report!</h3>
            )
          ) : (
            <h3>Please Select Month and Year to Generate Report!</h3>
          )}
        </Block>
      </Content>
    </React.Fragment>
  );
};

const tableHeaderStyle = {
  textAlign: "center",
  border: "1px solid black",
  color: "black",
  backgroundColor: "orange",
  padding: 10,
  fontWeight: "bold",
  verticalAlign: "inherit",
};

const leftColumnCell = {
  textAlign: "center",
  border: "1px solid black",
  padding: 10,
};
